import { KristoffelScrollMagicController } from './controllers/KristoffelScrollMagicController';
import { KristoffelAssortmentController } from './controllers/KristoffelAssortmentController';

window.addEventListener('load', () => {
  KristoffelScrollMagicController();
  KristoffelAssortmentController();
});



// WEBPACK FOOTER //
// ./src/js/app_kristoffel.js